import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function Users() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(null); // null | 'add' | user object
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'agent', is_active: 1 });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const load = async () => {
    const { data } = await api.get('/users');
    setUsers(data);
  };

  useEffect(() => { load(); }, []);

  const openAdd = () => { setForm({ name: '', email: '', password: '', role: 'agent', is_active: 1 }); setModal('add'); setError(''); };
  const openEdit = u => { setForm({ name: u.name, email: u.email, password: '', role: u.role, is_active: u.is_active }); setModal(u); setError(''); };

  const save = async () => {
    setError('');
    try {
      if (modal === 'add') {
        await api.post('/users', form);
      } else {
        await api.put(`/users/${modal.id}`, form);
      }
      setSuccess(modal === 'add' ? 'User created!' : 'User updated!');
      setModal(null);
      load();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) { setError(err.response?.data?.error || 'Error saving user'); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this user?')) return;
    await api.delete(`/users/${id}`);
    load();
  };

  const s = {
    page: { padding: 32, fontFamily: 'system-ui, sans-serif', maxWidth: 900, margin: '0 auto' },
    topRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 },
    title: { fontSize: 20, fontWeight: 600 },
    btn: { padding: '8px 16px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' },
    backBtn: { padding: '8px 14px', background: '#f0f0f0', color: '#555', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', marginRight: 12 },
    table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
    th: { padding: '10px 14px', fontSize: 12, color: '#aaa', textAlign: 'left', borderBottom: '1px solid #eee', background: '#fafafa' },
    td: { padding: '12px 14px', fontSize: 13, color: '#333', borderBottom: '1px solid #f5f5f5' },
    roleBadge: r => ({ background: r === 'admin' ? '#EEEDFE' : '#EAF3DE', color: r === 'admin' ? '#3C3489' : '#27500A', fontSize: 11, padding: '2px 8px', borderRadius: 8, fontWeight: 500 }),
    modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 },
    modal: { background: '#fff', borderRadius: 12, padding: 28, width: 360, boxShadow: '0 8px 32px rgba(0,0,0,0.16)' },
    modalTitle: { fontSize: 16, fontWeight: 600, marginBottom: 20 },
    label: { display: 'block', fontSize: 12, color: '#666', marginBottom: 4, marginTop: 12 },
    input: { width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' },
    select: { width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' },
    row: { display: 'flex', gap: 8, marginTop: 20 },
    primaryBtn: { flex: 1, padding: '9px 0', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' },
    cancelBtn: { flex: 1, padding: '9px 0', background: '#f0f0f0', color: '#555', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' },
    error: { background: '#FCEBEB', color: '#791F1F', padding: '8px 12px', borderRadius: 8, fontSize: 12, marginTop: 12 },
    success: { background: '#EAF3DE', color: '#27500A', padding: '8px 12px', borderRadius: 8, fontSize: 12, marginBottom: 16 },
    actionBtn: { fontSize: 12, padding: '4px 10px', border: '1px solid #ddd', borderRadius: 6, background: '#fff', cursor: 'pointer', marginRight: 6 },
  };

  return (
    <div style={s.page}>
      <div style={s.topRow}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button style={s.backBtn} onClick={() => navigate('/')}>← Back</button>
          <div style={s.title}>Users</div>
        </div>
        <button style={s.btn} onClick={openAdd}>+ Add user</button>
      </div>
      {success && <div style={s.success}>{success}</div>}
      <table style={s.table}>
        <thead>
          <tr>
            {['Name','Email','Role','Status','Actions'].map(h => <th key={h} style={s.th}>{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td style={s.td}>{u.name}</td>
              <td style={s.td}>{u.email}</td>
              <td style={s.td}><span style={s.roleBadge(u.role)}>{u.role}</span></td>
              <td style={s.td}><span style={{ color: u.is_active ? '#27500A' : '#aaa' }}>{u.is_active ? 'Active' : 'Inactive'}</span></td>
              <td style={s.td}>
                <button style={s.actionBtn} onClick={() => openEdit(u)}>Edit</button>
                <button style={{ ...s.actionBtn, color: '#c00', borderColor: '#f5c0c0' }} onClick={() => del(u.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modal && (
        <div style={s.modalOverlay} onClick={() => setModal(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitle}>{modal === 'add' ? 'Add user' : 'Edit user'}</div>
            {[
              { key: 'name', label: 'Full name', type: 'text' },
              { key: 'email', label: 'Email', type: 'email' },
              { key: 'password', label: modal === 'add' ? 'Password' : 'New password (leave blank to keep)', type: 'password' },
            ].map(f => (
              <div key={f.key}>
                <label style={s.label}>{f.label}</label>
                <input style={s.input} type={f.type} value={form[f.key]}
                  onChange={e => setForm({ ...form, [f.key]: e.target.value })} required={modal === 'add' || f.key !== 'password'} />
              </div>
            ))}
            <label style={s.label}>Role</label>
            <select style={s.select} value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
              <option value="agent">Agent</option>
              <option value="admin">Admin</option>
            </select>
            {modal !== 'add' && <>
              <label style={s.label}>Status</label>
              <select style={s.select} value={form.is_active} onChange={e => setForm({ ...form, is_active: parseInt(e.target.value) })}>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </>}
            {error && <div style={s.error}>{error}</div>}
            <div style={s.row}>
              <button style={s.primaryBtn} onClick={save}>{modal === 'add' ? 'Create' : 'Save'}</button>
              <button style={s.cancelBtn} onClick={() => setModal(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
